export const appColors = {
  primary: {
    50: "#fff",
    100: "#fafafa",
    200: "#f7fdff",
    300: "#f6fdff",
    400: "#efefef",
    500: "#e3e3e3",
    600: "#cccccc",
    700: "#d2d2d2",
    800: "#cfcfcf",
    900: "#c8c8c8",
  },
  secondary: {
    50: "#eff2f6",
    100: "#d2d8df",
    200: "#b3bec9",
    300: "#94a5b6",
    400: "#758ba3",
    500: "#5c728a",
    600: "#48586b",
    700: "#20262f",
    800: "#171a25",
    900: "#0d1019",
  },
  wzb: {
    50: "#e8e4ff",
    100: "#b8b2ff",
    200: "#8980ff",
    300: "#5a4dff",
    400: "#2d1aff",
    500: "#1300e6",
    600: "#0c00b4",
    700: "#070082",
    800: "#020050",
    900: "#010021",
  },
  wzy: {
    50: "#ffffda",
    100: "#ffffad",
    200: "#ffff7d",
    300: "#ffff4b",
    400: "#ffff1a",
    500: "#e5e600",
    600: "#b2b300",
    700: "#7f8000",
    800: "#4c4d00",
    900: "#191b00",
  },
  wzp: {
    50: "#f8e4ff",
    100: "#deb4ff",
    200: "#c783fd",
    300: "#af51fa",
    400: "#9821f8",
    500: "#7e07de",
    600: "#6204ae",
    700: "#46027d",
    800: "#2a004d",
    900: "#10001f",
  },
  wzg: {
    50: "#deffe3",
    100: "#b1feba",
    200: "#81fb8f",
    300: "#50f963",
    400: "#21f838",
    500: "#07de1f",
    600: "#00ad16",
    700: "#007b0d",
    800: "#004b05",
    900: "#001b00",
  },
  success: {
    50: "#dbfff3",
    100: "#b2fadf",
    200: "#85f7ca",
    300: "#57f2b6",
    400: "#2aeea1",
    500: "#11d587",
    600: "#03a568",
    700: "#00764a",
    800: "#00482b",
    900: "#001a0b",
  },
  warning: {
    50: "#fff9dc",
    100: "#faeeb2",
    200: "#f6e286",
    300: "#f2d658",
    400: "#eecb2a",
    500: "#d5b111",
    600: "#a58a09",
    700: "#766203",
    800: "#473b00",
    900: "#1a1400",
  },
  error: {
    50: "#ffe2f4",
    100: "#ffb3d7",
    200: "#fd83bb",
    300: "#fa51a0",
    400: "#f82185",
    500: "#de076c",
    600: "#ae0254",
    700: "#7d003c",
    800: "#4d0024",
    900: "#1f000e",
  },
};
